const Demo = () => {
  return (
      <div className="bg-white text-zinc-900 p-6 flex-1">
        <div className="mx-auto max-w-5xl w-full">
          <iframe
            src="https://zcal.co/i/emBkLIru?embed=1&embedType=iframe"
            loading="lazy"
            className="w-full min-h-screen border-none"
            id="zcal-invite"
            title="Schedule A Call"
            style={{ height: 'auto' }}
          />
          {/* <iframe 
            src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ2pDoeUukJqwpEuQUqlGwY7bhvMojUImWswofLnxKtaAQPwskl89t9TyGZQQYG7F1SFkDW6EwUY?gv=true" 
            className="w-full h-full min-h-[1100px] border-none"
            id="gcal-invite"
            title="Schedule A Call"
            loading="lazy"
          /> */}
        </div>
      </div>
  );
};

export default Demo;
